import log from 'salvo-lite/log'

class ActiveInput {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._elems = elem.querySelectorAll('.input-field__element')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elems.forEach(function (ele) {
            ele.addEventListener('change', (event) => {
                if (event.target.value.length > 0) {
                    event.target.parentNode.classList.add('input-field--active')
                } else {
                    event.target.parentNode.classList.remove('input-field--active')
                }
            })
        })
    }
}

export default ActiveInput



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ActiveInput.js